import React, { useState, useEffect } from "react";
import {
  Checkbox,
  Button,
  Typography,
  Box,
  Collapse,
  IconButton,
  MenuItem,
  Select,
  FormControl,Tooltip,
  InputLabel,DialogContent,Alert,DialogActions,DialogTitle,Dialog
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Getmenudata, GetUserdata, dataInsertonSubmit, dataRetrivewApi } from "../../../Api/Userpermission/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomAutocomplete from "../../../Components/AutoComplete/AutoComplete";

const UserPermission = () => {
  const [menus, setMenus] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState(null);
   const [copyDialogOpen, setCopyDialogOpen] = useState(false);
  const [sourceUserId, setSourceUserId] = useState(null);
  const [targetUserId, setTargetUserId] = useState(null);
  const [isCopying, setIsCopying] = useState(false);


const handleCopyPermissions = async () => {
  if (!sourceUserId || !targetUserId) {
    toast.error("Please select both source and target users");
    return;
  }

  if (sourceUserId === targetUserId) {
    toast.warning("Source and target users cannot be the same");
    return;
  }

  setIsCopying(true);

  try {
    let savedPermissions = [];
    
    // FIXED: Better API calls to get source user permissions
    const permissionPayloads = [
      { Start: 0, PageSize: 1000, UserId: sourceUserId },
      { Start: 0, PageSize: 1000, SearchText: sourceUserId.toString() }
    ];

    for (const payload of permissionPayloads) {
      try {
        console.log("Fetching source permissions with payload:", payload);
        const permissionResponse = await dataRetrivewApi(payload);
        
        // Check different possible response structures
        const permissions = permissionResponse?.data?.Data || 
                            permissionResponse?.Data || 
                            permissionResponse?.data || 
                            [];
        
        if (Array.isArray(permissions) && permissions.length > 0) {
          // FIXED: Strict filtering by sourceUserId
          savedPermissions = permissions.filter(p => {
            const permUserId = p.UserId || p.userId || p.User_id || p.user_id;
            return permUserId && (permUserId.toString() === sourceUserId.toString());
          });
          
          if (savedPermissions.length > 0) {
            console.log("Found source permissions:", savedPermissions);
            break;
          }
        }
      } catch (err) {
        console.log("Payload failed:", payload, err);
        continue;
      }
    }

    if (savedPermissions.length === 0) {
      toast.warning(`No permissions found for source user`);
      setIsCopying(false);
      return;
    }

    const sourceUser = usersList.find(user => user.Id === sourceUserId);
    const targetUser = usersList.find(user => user.Id === targetUserId);

    // FIXED: Properly map each permission with exact values from source
    const permissionsPayload = savedPermissions.map(perm => {
      // Helper function to get value from multiple possible field names
      const getValue = (fieldNames, defaultValue = 0) => {
        for (const name of fieldNames) {
          if (perm[name] !== undefined) {
            const val = perm[name];
            // Convert to 1/0 based on truthy values
            return (val === 1 || val === "1" || val === true) ? 1 : 0;
          }
        }
        return defaultValue;
      };

      return {
        UserPrevId: 0,
        UserId: parseInt(targetUserId, 10),
        ModuleId: perm.ModuleId || perm.moduleId || perm.Module_id,
        AllRec: "1",
        // Get exact values from source permission
        AddRec: getValue(['AddRec', 'addRec', 'Add', 'add', 'ADD_REC']),
        EditRec: getValue(['EditRec', 'editRec', 'Edit', 'edit', 'EDIT_REC']),
        DeleteRec: getValue(['DeleteRec', 'deleteRec', 'Delete', 'delete', 'DELETE_REC']),
        ReportRec: "1",
        ViewRec: getValue(['ViewRec', 'viewRec', 'View', 'view', 'VIEW_REC']),
        Status: perm.Status || "1"
      };
    });

    // Log the payload to verify exact values
    console.log("Copy Permissions Payload:", JSON.stringify(permissionsPayload, null, 2));

    let payload = {
      MstUserPrevList: permissionsPayload
    };

    let json = JSON.stringify(payload);
    json = json.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    json = '"' + json + '"';

    const response = await dataInsertonSubmit(json);

    if (response && response.status === 200) {
      toast.success(`Permissions copied successfully from ${sourceUser?.Name || "Source"} to ${targetUser?.Name || "Target"}`);
   
      if (targetUserId === selectedRoleId) {
        await fetchMenuDataAndPermissionsForUser(targetUserId);
      }
      
      setCopyDialogOpen(false);
    } else {
      toast.error("Failed to copy permissions. Please try again.");
    }
  } catch (error) {
    console.error("Error copying permissions:", error);
    toast.error("An error occurred while copying permissions.");
  } finally {
    setIsCopying(false);
  }
};

// Add this debug function to check the actual permissions in your state
const debugPermissions = () => {
  console.log("Current menus state:", menus);
  
  // Find ModuleId 5, 6, 7 and log their permissions
  const findModule = (nodes, moduleId) => {
    for (const node of nodes) {
      if (node.ModuleId === moduleId) {
        return node;
      }
      if (node.children) {
        const found = findModule(node.children, moduleId);
        if (found) return found;
      }
    }
    return null;
  };

  [5, 6, 7].forEach(id => {
    const module = findModule(menus, id);
    if (module) {
      console.log(`Module ${id} permissions:`, module.permissions);
    } else {
      console.log(`Module ${id} not found`);
    }
  });
};

// Call this after permissions are loaded
useEffect(() => {
  if (menus.length > 0) {
    debugPermissions();
  }
}, [menus]);

  const handleOpenCopyDialog = () => {
    if (selectedRoleId) {
      setSourceUserId(selectedRoleId);
      setTargetUserId(null);
      setCopyDialogOpen(true);
    } else {
      toast.warning("Please select a user first to copy permissions from");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (selectedRoleId) {
      fetchMenuData();
      fetchMenuDataAndPermissions();
    }
  }, [selectedRoleId]);

  const fetchUsers = async () => {
    try {
      const response = await GetUserdata({});
      const userData = response?.data?.Data || [];
      
      if (Array.isArray(userData) && userData.length > 0) {
        setUsersList(userData);
        
        // Automatically select first user
        const firstUser = userData[1];
        setSelectedRoleId(firstUser.Id);
        setSelectedRole(firstUser.Name || "");
        setSelectedUsers([firstUser.Id]);
                
        // Automatically fetch menu data and permissions for first user
        setTimeout(async () => {
          await fetchMenuDataAndPermissionsForUser(firstUser.Id);
        }, 100);
        
      } else {
        setUsersList([]);
      }
    } catch (error) {
      setUsersList([]);
    }
  };
  
const fetchMenuDataAndPermissionsForUser = async (userId) => {
  try {
    const menuPayload = { Id: userId };
    const menuResponse = await Getmenudata(menuPayload);
    const menuData = menuResponse?.data?.Data || [];

    if (Array.isArray(menuData)) {
      const initialTree = buildTree(menuData);
      
      // FIXED: Better permission fetching with multiple attempts
      let savedPermissions = [];
      
      // Try multiple API call patterns
      const permissionPayloads = [
        { Start: 0, PageSize: 1000, UserId: userId },
        { Start: 0, PageSize: 1000, SearchText: userId.toString() }
      ];

      for (const payload of permissionPayloads) {
        try {
          console.log("Fetching permissions with payload:", payload);
          const permissionResponse = await dataRetrivewApi(payload);
          
          // Check different possible response structures
          const permissions = permissionResponse?.data?.Data || 
                              permissionResponse?.Data || 
                              permissionResponse?.data || 
                              [];
          
          if (Array.isArray(permissions) && permissions.length > 0) {
            // FIXED: Strict filtering by userId
            savedPermissions = permissions.filter(p => {
              const permUserId = p.UserId || p.userId || p.User_id || p.user_id;
              return permUserId && (permUserId.toString() === userId.toString());
            });
            
            if (savedPermissions.length > 0) {
              console.log("Found permissions for user:", userId, savedPermissions);
              break;
            }
          }
        } catch (err) {
          console.log("Payload failed:", payload, err);
          continue;
        }
      }

      // Log the retrieved permissions for debugging
      console.log("Retrieved permissions for user", userId, ":", savedPermissions);

      // Update tree with permissions
      const updatedTree = updateTreeWithPermissions(initialTree, savedPermissions);
      setMenus(updatedTree);
    }
  } catch (error) {
    console.error("Error in fetchMenuDataAndPermissionsForUser:", error);
  }
};

  const fetchMenuDataAndPermissions = async () => {
    try {
      const menuPayload = { Id: selectedRoleId };
      const menuResponse = await Getmenudata(menuPayload);
      const menuData = menuResponse?.data?.Data || [];

      if (selectedRoleId) {
        await fetchMenuDataAndPermissionsForUser(selectedRoleId);
      }
  
      if (Array.isArray(menuData)) {
        const initialTree = buildTree(menuData);
        setMenus(initialTree);
  
        let savedPermissions = [];
        
        try {
          const permissionPayloads = [
            {
              Start: 0,
              PageSize: 1000,
              UserId: selectedRoleId
            },
            {
              Start: 0,
              PageSize: 1000,
              SearchText: selectedRoleId.toString()
            },
            {
              Start: 0,
              PageSize: 1000,
              Filter: {
                UserId: selectedRoleId
              }
            }
          ];
  
          for (const payload of permissionPayloads) {
            try {
              const permissionResponse = await dataRetrivewApi(payload);
              const permissions = permissionResponse?.data?.Data || [];
              
              if (Array.isArray(permissions) && permissions.length > 0) {
                savedPermissions = permissions.filter(p => 
                  p.UserId === selectedRoleId || 
                  p.UserId === selectedRoleId.toString()
                );
                
                if (savedPermissions.length > 0) {
                  console.log("Found permissions for user:", selectedRoleId, savedPermissions);
                  break;
                }
              }
            } catch (err) {
              continue;
            }
          }
        } catch (error) {
        }
  
        if (savedPermissions.length === 0) {
          try {
            console.log("No specific user permissions found, trying to get first available data...");
            
            const fallbackPayload = {
              Start: 0,
              PageSize: 1000,
              SearchText: ""
            };
            
            const fallbackResponse = await dataRetrivewApi(fallbackPayload);
            const allPermissions = fallbackResponse?.data?.Data || [];
            
            if (Array.isArray(allPermissions) && allPermissions.length > 0) {
              const firstUserPermissions = allPermissions.slice(0, 50);
              savedPermissions = firstUserPermissions;
            }
          } catch (fallbackError) {
            console.log("Fallback method also failed:", fallbackError);
          }
        }
  
        if (savedPermissions.length > 0) {
          const updatedTree = updateTreeWithPermissions(initialTree, savedPermissions);
          setMenus(updatedTree);
        } else {
          setMenus(initialTree);
        }
      }
    } catch (error) {
      try {
        const menuPayload = { Id: selectedRoleId };
        const menuResponse = await Getmenudata(menuPayload);
        const menuData = menuResponse?.data?.Data || [];
        if (Array.isArray(menuData)) {
          const initialTree = buildTree(menuData);
          setMenus(initialTree);
        }
      } catch (finalError) {
        console.error("Final fallback also failed:", finalError);
      }
    }
  };
  
const updateTreeWithPermissions = (tree, permissions) => {
  console.log("Updating tree with permissions:", permissions);
  
  const updateNode = (nodes) => {
    return nodes.map(node => {
      // FIXED: Better matching for ModuleId
      const savedPermission = permissions.find(p => {
        const permModuleId = p.ModuleId || p.moduleId || p.Module_id || p.module_id;
        return permModuleId && (permModuleId.toString() === node.ModuleId.toString());
      });

      if (savedPermission) {
        console.log(`Found permission for ModuleId ${node.ModuleId}:`, savedPermission);
        
        // FIXED: Properly extract permission values with multiple field name variations
        const extractValue = (fieldNames) => {
          for (const name of fieldNames) {
            if (savedPermission[name] !== undefined) {
              const val = savedPermission[name];
              // Convert to boolean: true if 1, "1", true
              return val === 1 || val === "1" || val === true;
            }
          }
          return false;
        };

        // Check all possible field names for each permission type
        const addPermission = extractValue(['AddRec', 'addRec', 'Add', 'add', 'ADD_REC']);
        const viewPermission = extractValue(['ViewRec', 'viewRec', 'View', 'view', 'VIEW_REC']);
        const editPermission = extractValue(['EditRec', 'editRec', 'Edit', 'edit', 'EDIT_REC']);
        const deletePermission = extractValue(['DeleteRec', 'deleteRec', 'Delete', 'delete', 'DELETE_REC']);

        const hasAnyPermission = addPermission || viewPermission || editPermission || deletePermission;

        return {
          ...node,
          checked: hasAnyPermission,
          expanded: false,
          permissions: {
            Add: addPermission,
            View: viewPermission,
            Edit: editPermission,
            Delete: deletePermission
          },
          children: node.children ? updateNode(node.children) : []
        };
      }

      return {
        ...node,
        expanded: false,
        checked: false,
        permissions: {
          Add: false,
          View: false,
          Edit: false,
          Delete: false
        },
        children: node.children ? updateNode(node.children) : []
      };
    });
  };
  return updateNode(tree);
};
  
  const handleSubmit = async () => {
    const getPermissions = (nodes) => {
      let permissions = [];
      nodes.forEach((node) => {
        if (node.checked) {
          permissions.push({
            UserPrevId: 0,
            UserId: parseInt(selectedRoleId, 10),
            ModuleId: node.ModuleId,
            AllRec: 1,
            AddRec: node.permissions.Add ? 1 : 0,
            EditRec: node.permissions.Edit ? 1 : 0,
            DeleteRec: node.permissions.Delete ? 1 : 0,
            ReportRec: 1,
            ViewRec: node.permissions.View ? 1 : 0,
            Status: "1"
          });
        }
  
        if (node.children) {
          permissions = [...permissions, ...getPermissions(node.children)];
        }
      });
      return permissions;
    };
  
    const permissionsPayload = getPermissions(menus);
  
    if (permissionsPayload.length === 0) {
      toast.warning("No permissions selected for submission.");
      return;
    }
  
    let payload = {
      MstUserPrevList: permissionsPayload
    };
  
    try {
      let json = JSON.stringify(payload);
      json = json.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
      json = '"' + json + '"';
  
      const response = await dataInsertonSubmit(json);
  
      if (response && response.status === 200) {
        toast.success("Permissions submitted successfully!");
        
        setTimeout(async () => {
          await fetchMenuDataAndPermissions();
        }, 1000);
  
      } else {
        toast.error("Failed to submit permissions. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while submitting permissions.");
    }
  };

  const fetchMenuData = async () => {
    try {
      const payload = { Id: selectedRoleId };
      const response = await Getmenudata(payload);
      const menuData = response?.data?.Data || [];

      if (Array.isArray(menuData)) {
        const tree = buildTree(menuData);
        setMenus(tree);
      }
    } catch (error) {
      console.error("Error fetching menu data:", error);
    }
  };

  const buildTree = (data) => {
    const idToNodeMap = {};
    const rootNodes = [];

    data.forEach((item) => {
      const node = {
        ...item,
        children: [],
        expanded: false, // FIXED: Set all nodes to collapsed by default
        checked: false,
        permissions: {
          Add: false,
          View: false,
          Edit: false,
          Delete: false
        },
        Level: parseInt(item.Level, 10)
      };
      idToNodeMap[item.ModuleId] = node;
    });

    data.forEach((item) => {
      const node = idToNodeMap[item.ModuleId];
      if (item.ParentId === null || item.ParentId === 0 || item.ParentId === "0") {
        rootNodes.push(node);
      } else if (idToNodeMap[item.ParentId]) {
        idToNodeMap[item.ParentId].children.push(node);
      }
    });

    return rootNodes;
  };

  const handleRoleChange = (event) => {
    const selectedId = event.target.value;
    const selectedUser = usersList.find(user => user.Id === selectedId);
    setSelectedRoleId(selectedId);
    setSelectedRole(selectedUser?.Name || "");
    setSelectedUsers([selectedId]);
  };

const handlePermissionChange = (moduleId, permissionType, checked) => {
  setMenus((prevMenus) => {
    const findNodeAndPath = (nodes, targetId, path = []) => {
      for (const node of nodes) {
        if (node.ModuleId === targetId) {
          return { node, path };
        }
        if (node.children) {
          const result = findNodeAndPath(node.children, targetId, [...path, node]);
          if (result.node) return result;
        }
      }
      return { node: null, path: [] };
    };

    const updateNodeState = (nodes, nodeId) => {
      return nodes.map(node => {
        if (node.ModuleId === nodeId) {
          const anyPermissionChecked = Object.values(node.permissions).some(val => val);
          return {
            ...node,
            checked: anyPermissionChecked,
            children: node.children ? updateNodeState(node.children, nodeId) : []
          };
        }
        return {
          ...node,
          children: node.children ? updateNodeState(node.children, nodeId) : []
        };
      });
    };

    let newMenus = [...prevMenus];
    const { node: targetNode, path } = findNodeAndPath(newMenus, moduleId);

    if (targetNode) {
      targetNode.permissions[permissionType] = checked;
      const hasAnyPermission = Object.values(targetNode.permissions).some(val => val);
      targetNode.checked = hasAnyPermission;


    }

    return newMenus;
  });
};

  const handleCheckboxChange = (node, checked) => {
    setMenus((prevMenus) => {
      const findNodeAndPath = (nodes, targetId, path = []) => {
        for (const n of nodes) {
          if (n.ModuleId === targetId) {
            return { node: n, path };
          }
          if (n.children) {
            const result = findNodeAndPath(n.children, targetId, [...path, n]);
            if (result.node) return result;
          }
        }
        return { node: null, path: [] };
      };

      const hasCheckedChild = (nodeToCheck) => {
        if (!nodeToCheck.children) return false;

        for (const child of nodeToCheck.children) {
          if (child.checked) return true;
          if (hasCheckedChild(child)) return true;
        }
        return false;
      };

      const updateChildren = (n, isChecked) => {
        return {
          ...n,
          checked: isChecked,
          expanded: n.expanded, // Maintain current expanded state
          permissions: {
            Add: isChecked,
            View: isChecked,
            Edit: isChecked,
            Delete: isChecked
          },
          children: n.children ? n.children.map(child => updateChildren(child, isChecked)) : []
        };
      };

      let newMenus = [...prevMenus];
      const { node: targetNode, path } = findNodeAndPath(newMenus, node.ModuleId);

      if (targetNode) {
        if (checked) {
          path.forEach(parentNode => {
            parentNode.checked = true;
            parentNode.permissions = {
              Add: true,
              View: true,
              Edit: true,
              Delete: true
            };
          });

          Object.assign(targetNode, updateChildren(targetNode, checked));
        } else {
          Object.assign(targetNode, updateChildren(targetNode, checked));

          path.forEach(parentNode => {
            if (!hasCheckedChild(parentNode)) {
              parentNode.checked = false;
              parentNode.permissions = {
                Add: false,
                View: false,
                Edit: false,
                Delete: false
              };
            }
          });
        }
      }

      return newMenus;
    });
  };

  const hasActivePermissions = (node) => {
    return Object.values(node.permissions).some(val => val);
  };

  useEffect(() => {
    console.log('Current Menu State:', menus);
  }, [menus]);

  const renderPermissionButtons = (node) => {
    if (!node.children || node.children.length === 0) {
      return (
        <Box sx={{
          display: "flex",
          alignItems: "center",
          ml: 1,
          borderLeft: "1px solid #e0e0e0",
          paddingLeft: 2,
          height: "30px",
          gap: 0.5
        }}>
          {["Add", "Edit", "Delete", "View"].map((permission) => (
            <Box
              key={permission}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: node.permissions[permission] ? "#e3f2fd" : "#f5f5f5",
                borderRadius: 1,
                width: "80px",
                height: "22px",
              }}
            >
              <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                width: "100%",
                pl: 1
              }}>
                <Checkbox
                  size="small"
                  checked={node.permissions[permission]}
                  onChange={(e) => handlePermissionChange(node.ModuleId, permission, e.target.checked)}
                  sx={{
                    padding: "4px",
                    '& .MuiSvgIcon-root': { fontSize: 20 }
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.75rem",
                    color: node.permissions[permission] ? "#1976d2" : "text.secondary",
                    ml: 0.5
                  }}
                >
                  {permission}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      );
    }
    return null;
  };

  const renderTree = (nodes) => {
    return nodes.map((node) => (
      <Box
        key={node.ModuleId}
        sx={{
          pl: node.Level * 1,
          mt: 0.2,
          borderLeft: node.Level > 0 ? "1px dashed #ccc" : "none",
          padding:'0px'
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: node.checked ? "rgba(25, 118, 210, 0.04)" : "transparent",
            borderRadius: 1,
            minHeight: "20px",
          }}
        >
          <IconButton
            onClick={() => {
              setMenus((prevMenus) => {
                const updateExpanded = (nodes) => {
                  return nodes.map((n) => {
                    if (n.ModuleId === node.ModuleId) {
                      return { ...n, expanded: !n.expanded };
                    }
                    if (n.children) {
                      return { ...n, children: updateExpanded(n.children) };
                    }
                    return n;
                  });
                };
                return updateExpanded(prevMenus);
              });
            }}
            sx={{
              visibility: node.children?.length ? "visible" : "hidden",
              p: 0.5,
              mr: 0.5,
              "& svg": { fontSize: "1rem" }
            }}
          >
            {node.expanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>

          <Checkbox
            size="small"
            checked={node.checked}
            onChange={(e) => handleCheckboxChange(node, e.target.checked)}
            sx={{
              mr: 0.5,
              padding: "4px",
              '& .MuiSvgIcon-root': { fontSize: 20 }
            }}
          />

          <Typography
            variant="body2"
            sx={{
              fontWeight: node.Level === 0 ? 600 : 400,
              fontSize: "0.85rem",
              color: node.Level === 0 ? "black" : "text.primary",
              minWidth: "150px"
            }}
          >
            {node.ModuleName}
          </Typography>

          {renderPermissionButtons(node)}
        </Box>

        <Collapse in={node.expanded} timeout="auto" unmountOnExit>
          <Box sx={{ ml: 1 }}>
            {node.children && node.children.length > 0 && renderTree(node.children)}
          </Box>
        </Collapse>
      </Box>
    ));
  };

  return (
   <Box sx={{ p: 5, backgroundColor: "#F5F5F5", minHeight: "70vh" }}>
      <ToastContainer />

      <Dialog 
        open={copyDialogOpen} 
        onClose={() => setCopyDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ContentCopyIcon />
            Copy Permissions
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Copy permissions from one user to another
            </Typography>
            
            <Box sx={{ mt:2 }}>
              <FormControl fullWidth variant="filled" className="custom-select" sx={{height:'42px'}}>
                <InputLabel>Copy From (Source User)</InputLabel>
                <Select
                  value={sourceUserId || ''}
                  onChange={(e) => setSourceUserId(e.target.value)}
                  label="Copy From (Source User)"
                >
                  {usersList.map((user) => (
                    <MenuItem key={user.Id} value={user.Id}>
                      {user.Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
                <SwapHorizIcon sx={{ color: 'action.active', fontSize: 40 }} />
              </Box>

              <FormControl fullWidth variant="filled" className="custom-select" sx={{height:'42px'}}>
                <InputLabel>Copy To (Target User)</InputLabel>
                <Select
                  value={targetUserId || ''}
                  onChange={(e) => setTargetUserId(e.target.value)}
                  label="Copy To (Target User)"
                >
                  {usersList.map((user) => (
                    <MenuItem key={user.Id} value={user.Id}>
                      {user.Name} 
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Alert severity="warning" sx={{ mt: 2 }}>
                This will overwrite all existing permissions for the target user.
              </Alert>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCopyDialogOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleCopyPermissions} 
            color="primary" 
            variant="contained"
            disabled={!sourceUserId || !targetUserId || isCopying}
            startIcon={<ContentCopyIcon />}
          >
            {isCopying ? "Copying..." : "Copy Permissions"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: 2,
        p: 3
      }}>
        <Box sx={{
          width: "100%",

        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333",mb:1 }}>
              Please Select User for Permissions
            </Typography>

            <Tooltip title="Copy permissions to another user">
              <Button
                variant="outlined"
                startIcon={<ContentCopyIcon />}
                onClick={handleOpenCopyDialog}
                sx={{ ml: 2 }}
                disabled={!selectedRoleId}
              >
                Copy Permissions
              </Button>
            </Tooltip>
          </Box>

          <Box sx={{
            width: "42.7%",
            marginRight: "auto",
            mb: 1
          }}>
            <CustomAutocomplete
              id="user-select"
              name="user"
              options={usersList}
              value={usersList.find(user => user.Id === selectedRoleId) || null}
              onChange={handleRoleChange}
              label="Select User"
              error={false}
              helperText=""
            />
          </Box>
        </Box>

        {selectedRoleId && (
          <>
            <Box sx={{ maxHeight: "70vh", overflow: "auto" }}>
              {menus.length > 0 ? renderTree(menus) : <Typography>Loading menu...</Typography>}
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button
                onClick={handleSubmit}
                sx={{
                  background: "#1976D2",
                  textTransform: "none",
                  color: "white",
                  "&:hover": { background: "#1565C0" },
                  px: 4
                }}
              >
                Submit
              </Button>
              
              {/* <Button
                onClick={handleOpenCopyDialog}
                variant="outlined"
                startIcon={<ContentCopyIcon />}
                sx={{ textTransform: "none" }}
              >
                Copy These Permissions
              </Button> */}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default UserPermission;